import React from 'react';
import {Editor} from '../editor-components';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import Spinner from '../spinner/spinner';
import ContentsList from '../booth-editor/contents-list';
import ScreenEmulator from '../screen-emulator/screen-emulator';

/** @class ShowbagContents
  * A component for setting the inital showbag contents
  * @param {Object} props - the component's properties
  */
export default class ShowbagContents extends ReactFireComponent {
  constructor(props){
    super(props);
    this.state = {}
    this.dataURL = props.dataURL + '/contents';
  }
  /** @function componentWillMount
    * Connects the component to its firebase realtime
    * database entry
    */
  componentWillMount(){
    this.bindAsObject(this.dataURL, 'contents');
  }
  /** @function componentWillUnmount
    * Disconnects the component from the firebase database.
    */
  componentWillUnmount(){
    this.unbind('contents');
  }
  /** @function render
    * Renders the component
    */
  render() {
    if(!this.state.contents) return <Spinner />
    return (
      <Editor>
        <p>The specfied content items are pre-loaded in all showbags</p>
        <div className="content-tab">
          <div className="sidebar">
            <ContentsList contents={this.state.contents} dataURL={this.dataURL} />
          </div>
          <div className="screen">
            <ScreenEmulator src={`/preview/${this.props.expoID}/${this.props.showID}/#/showbag`} />
          </div>
        </div>
      </Editor>
    )
  }
}



// WEBPACK FOOTER //
// ./src/showbag-editor/showbag-contents.js